<!-- <app-sidebar></app-sidebar> -->
<app-hire-sidebar></app-hire-sidebar>
<!-- <app-navbar></app-navbar> -->

<div class="getstartedrow">
  <!-- <p class="font-weight-600 f-20">Get Started Quickly</p> -->
  <div class="wccard p-3">
    <div class="job-creation-box">
      <div class="type-of-job-box">
        <div class="ai-globe-search-pink">
           <span><img src="../../assets/resume-screening/screen-globe-1.svg" alt=""></span>
        </div>
        <div class="welcome-text">
          <h1 class="f-18 font-weight-600 mb-1">Welcome to <span>Screen<span class="ai-text">AI</span></span></h1>
          <p class="mb-0 f-12 font-weight-400">Select Get Started to create or import a job for improved candidate screening.</p>
        </div>
      </div>
      <div class="type-of-job-box">
        <div class="dropdown">
          <a data-testid="auto-app-resume-screen-a-1" class="btn btn-secondary dropdown-toggle text-white" role="button" appDropdownToggle aria-expanded="false">
            Get Started
          </a>

          <div class="dropdown-menu">
            <a data-testid="auto-app-resume-screen-a-2" class="dropdown-item"  (click)="createJob()">
              <div class="menu-item">
                <div class="circular-w">
                  <img src="../../assets/resume-screening/web-logo.png" style="width: 90%;" alt="">
                </div>
                <div class="menu-content">
                    <h3>Create Job</h3>
                    <p>Set up a new job and start screening<br> candidates with Screen AI</p>
                </div>
              </div>
            </a>
            <a data-testid="auto-app-resume-screen-a-3" *ngIf="availableIntegrations && availableIntegrations.length && isTeamAdmin" class="dropdown-item" (click)="openJobListModel()">
              <div class="menu-item">
                <div class="circular-w">
                   <i class="fa-solid fa-briefcase-arrow-right f-18 font-weight-400"></i>
                </div>
                <div class="menu-content">
                     <h3>Import job from ATS</h3>
                    <p>Use an existing job and candidates <br> from your connected ATS</p>
                </div>
              </div>
            </a>
            <a data-testid="auto-app-resume-screen-a-4" *ngIf="!availableIntegrations.length && isTeamAdmin" class="dropdown-item" (click)="connectATS()">
              <div class="menu-item">
                <div class="circular-w">
                   <i class="fa-solid fa-triangle-exclamation f-18 font-weight-400" style="color: #E8CD00;"></i>
                </div>
                <div class="menu-content" *ngIf="isTeamAdmin">
                    <h3 class="text-9696 font-weight-500">Import job from ATS</h3>
                    <p>To continue, <a data-testid="auto-app-resume-screen-a-5" class="text-webbtree-green font-weight-500">Connect your ATS <i class="fa-regular fa-arrow-up-right-from-square"></i></a> </p>
                </div>
                <div class="menu-content" *ngIf="!isTeamAdmin">
                    <h3 class="text-9696 font-weight-500">You do not have permission to import</h3>
                </div>
              </div>
            </a>
          </div>
        </div>

      </div>

    </div>
  </div>
</div>

<!-- Landing page  -->
<div class="landing-screen" *ngIf="jobsList?.length === 0 && !searchInput.value">
    <app-landing-page></app-landing-page>
</div>

<!-- Jobs search section -->
<div class="wccard px-3 py-2 mt-1" *ngIf="jobsList?.length != 0 || (jobsList?.length == 0 && searchInput.value)">
    <div class="row">
        <div class="col-12 d-flex justify-content-between align-items-center">
            <div>
                <span class="f-16 font-weight-600" style="color: #484B59;">Jobs</span>
            </div>
            <div class="d-flex align-items-center searchicon">
                <input data-testid="auto-app-resume-screen-input-1" style="width: 300px; padding-right: 33px;" type="text" class="wc-form-control nobg " [formControl]="searchInput"
                    placeholder="Search Job Name">
            </div>
        </div>
    </div>
</div>

<!-- Jobs search section -->
<!-- <div class="wccard px-3 py-2 mt-1">
    <div class="row">
       <div class="pointer ml-2" [ngClass]="jobImportedTab ? 'active' : ''" (click)="onTabChanges('importedTab')">Imported Jobs</div>
       <div class="ml-2 pointer" [ngClass]="jobCreatedTab ? 'active' : ''" (click)="onTabChanges('createdTab')">Created Jobs</div>
    </div>
</div> -->

<!-- For job List -->
<div class="row" *ngIf="jobsList?.length != 0 || (jobsList?.length == 0 && searchInput.value)">
    <!-- If jobs List Not Available -->
    <div *ngIf="jobsList.length === 0" class="col">
        <div class="w-100 wccard" style="height: 439px; display: flex; justify-content: center; align-items: center;">
            <div class="text-center">
                <img style="width: 203px; height: 132px;" src="../../../assets/empty-credit.png" alt="empty_logo">
                <p class="f-14 font-weight-600 text-center mb-1 mt-2" style="color: #969696;">No jobs found</p>
                 <p class="f-14 font-weight-500 text-center" style="color: #969696;">Your search did not match any jobs. Please try again</p>
            </div>
        </div>
    </div>

    <!-- If job List Available -->
    <div class="col" *ngIf="jobsList.length > 0">
        <!-- Table Header Row -->
        <div class="wccard py-2 px-3 mt-2px">
            <div class="row">
                <div class="col-5">
                    <span class="f-14 font-weight-400" style="color: #969696;">Job Details</span>
                </div>
                <div class="col">
                    <span class="f-14 font-weight-400" style="color: #969696;">Candidates</span>
                </div>
                <div class="col">
                    <span class="f-14 font-weight-400" style="color: #969696;">Updated On</span>
                </div>
                <!-- <div class="col">
                    <span class="f-14 font-weight-400" style="color: #969696;">Status</span>
                </div> -->
                <div class="col  text-right">
                    <span class="f-14 font-weight-400" style="color: #969696;">Action</span>
                </div>
            </div>
        </div>

        <!-- Data Rows -->
        <div class="wccard py-2 px-3 mt-4px" *ngFor="let job of jobsList">
            <div class="row">
                <div class="col-5 text-truncate d-flex align-items-center" [ngClass]="!job?.location ? 'py-2' : 'py-0'">
                  <!-- <div>
                    <div class="companylogo">
                        <i class="fa-solid fa-puzzle"></i>
                    </div>
                    </div> -->
                    <div>
                        <p class="f-14 font-weight-500 pointer text-truncate text-blue d-flex" (click)="handleRedirect(job)" [ngClass]="job?.location ? 'mb-1' : 'mb-0'">
                          <span matTooltip="{{job.name}}" [matTooltipClass]="{ 'red-tooltip text-black': true }">{{ job.name | titlecase }}</span>
                          <span *ngIf="job.source == 'create'" class="jobcretedicon" matTooltip="Job Created on Webbtree" [matTooltipClass]="{ 'red-tooltip text-black': true }"><img src="../../assets/resume-screening/web-logo.png" alt=""></span>
                        </p>
                        <p class="f-12 text-9696 mb-0" *ngIf="job?.location"><i class="fa-regular fa-location-dot mr-1" *ngIf="job?.location"></i>{{job?.location | titlecase }}</p>
                    </div>
                </div>

                <div class="col d-flex align-items-center">
                    <span class="f-14 font-weight-400">
                        {{ job.applications_count }}
                    </span>
                </div>

                <div class="col d-flex align-items-center">
                    <span class="f-12 font-weight-400 text-9696">
                        <i class="fa-regular fa-clock mr-1"></i>
                        {{ job.createdon | date: 'MMM d, y' }}
                    </span>
                </div>

                <!-- <div class="col d-flex align-items-center">
                    <span class="f-14 font-weight-400 active-label">
                        Active
                    </span>
                </div> -->

                <div class="col d-flex align-items-center justify-content-end">
                    <!-- <span class="f-14 font-weight-500" *ngIf="job?.source == 'import'">
                        <button data-testid="auto-app-resume-screen-button-1" class="btn-trms-light-with-border w-100 ml-2"
                            *ngIf="(!job?.sync_status && !job?.groq_status) || (job?.sync_status == 'failed' || job?.groq_status == 'failed') || ((job?.sync_status && job?.sync_status == 'completed') && !job?.groq_status)"
                            [ngClass]="{ 'text-center': startScreeningLoader, 'bg-gray': startScreeningLoader && job?.ats_job_id != startScreeningSelectedJobid }"
                            (click)="startScreening(job)" [disabled]="startScreeningLoader">
                            <span *ngIf="job?.ats_job_id == startScreeningSelectedJobid">
                                <span [ngClass]="{ 'spinner-border text-blue spinner-size': startScreeningLoader }"
                                    [ngStyle]="startScreeningLoader ? { width: '20px', height: '20px' } : {}">
                                </span>
                                <span class="position-relative" *ngIf="!startScreeningLoader">
                                  Run Screen<span class="ai-text2">AI</span>
                                </span>
                            </span>
                            <span *ngIf="job?.ats_job_id != startScreeningSelectedJobid">
                              <span class="position-relative" *ngIf="((!job?.sync_status && !job?.groq_status) && (job?.sync_status !== 'failed' || job?.groq_status !== 'failed') )">
                                Run Screen<span class="ai-text2">AI</span>
                              </span>
                                <span *ngIf="!((!job?.sync_status && !job?.groq_status) && (job?.sync_status !== 'failed' || job?.groq_status !== 'failed') )">
                                Re Run
                              </span>
                              </span>
                        </button>

                        <span class="f-14 font-weight-400 gen-ai-text" *ngIf="((job?.sync_status && job?.sync_status == 'in-progress') || (job?.groq_status == 'pending'))">Screening In process</span>
                        <span class="text-blue pointer" (click)="viewCandidates(job)" *ngIf="(job?.sync_status == 'completed' && job?.groq_status == 'completed')">View Candidates</span>
                    </span> -->

                    <span class="f-14 font-weight-500" *ngIf="job?.source === 'import'">

                        <!-- SCREENING IN PROGRESS -->
                        <span class="f-14 font-weight-400 gen-ai-text" *ngIf="isScreeningInProgress(job)">
                            Screening in process
                        </span>

                        <!-- VIEW CANDIDATES -->
                        <span class="text-blue pointer" *ngIf="job?.sync_status === 'completed' && job?.groq_status === 'completed'"
                            (click)="viewCandidates(job)">
                            View Candidates
                        </span>

                        <!-- RUN / RE-RUN SCREEN AI -->
                        <!-- <button data-testid="auto-app-resume-screen-button-2" class="btn-trms-light-with-border w-100 ml-2" *ngIf="showRunButton(job)" [disabled]="startScreeningLoader || !availableIntegrations?.length"
                            (click)="startScreening(job)" [matTooltip]="!availableIntegrations?.length ? 'Please connect your ATS' : ''"
                            [matTooltipDisabled]="!!availableIntegrations?.length" [matTooltipClass]="{ 'red-tooltip text-black': true }"
                            [ngClass]="{'text-center': startScreeningLoader, 'bg-gray': startScreeningLoader && job?.ats_job_id == startScreeningSelectedJobid }">

                            <span *ngIf="job?.ats_job_id === startScreeningSelectedJobid && startScreeningLoader">
                                <span class="spinner-border text-blue spinner-size" [ngStyle]="{ width: '20px', height: '20px' }">
                                </span>
                            </span>

                            <span *ngIf="!startScreeningLoader || (startScreeningLoader && job?.ats_job_id !== startScreeningSelectedJobid)">
                                {{ getRunButtonText(job) }}
                            </span>
                        </button> -->
                        <span [matTooltip]="screeningTooltip"
                            [matTooltipDisabled]="!!availableIntegrations?.length" matTooltipClass="red-tooltip text-black">

                            <button data-testid="auto-app-resume-screen-button-3" class="btn-trms-light-with-border w-100 ml-2" *ngIf="showRunButton(job)" (click)="startScreening(job)"
                                [disabled]="startScreeningLoader || !availableIntegrations?.length || !isTeamAdmin"
                                [ngClass]="{
                                    'text-center': startScreeningLoader,
                                    'bg-gray': startScreeningLoader && job?.ats_job_id == startScreeningSelectedJobid,
                                    'btn-disabled-ui': !availableIntegrations?.length || !isTeamAdmin
                                }">
                                <span *ngIf="job?.ats_job_id === startScreeningSelectedJobid && startScreeningLoader">
                                    <span class="spinner-border text-blue spinner-size" [ngStyle]="{ width: '20px', height: '20px' }"></span>
                                </span>

                                <span *ngIf="!startScreeningLoader || (startScreeningLoader && job?.ats_job_id !== startScreeningSelectedJobid)">
                                    {{ getRunButtonText(job) }}
                                </span>
                            </button>
                        </span>

                    </span>

                    <span class="f-14 font-weight-500" *ngIf="job?.source == 'create'">

                        <!-- <button data-testid="auto-app-resume-screen-button-4" class="btn-trms-white w-100 ml-2" *ngIf="!job?.groq_status || job?.sync_status == 'failed'"
                            [ngClass]="{ 'text-center': startScreeningLoader, 'bg-gray': startScreeningLoader && job?.ats_job_id != startScreeningSelectedJobid }"
                            (click)="startScreening(job)" [disabled]="startScreeningLoader">
                            <span *ngIf="job?.ats_job_id == startScreeningSelectedJobid">
                                <span [ngClass]="{ 'spinner-border text-blue spinner-size': startScreeningLoader }"
                                    [ngStyle]="startScreeningLoader ? { width: '20px', height: '20px' } : {}">
                                    {{ startScreeningLoader ? '' : 'Start Screening' }}
                                </span>
                            </span>
                            <span *ngIf="job?.ats_job_id != startScreeningSelectedJobid">{{job?.groq_status == 'failed' ? 'Re-Run' : 'Start
                                Screening'}}</span>
                        </button> -->

                        <button data-testid="auto-app-resume-screen-button-5" class="btn-trms-regular upload-candidate-btn" *ngIf="!job?.groq_status || job?.sync_status == 'failed'" (click)="uploadCandidate(job?.ats_job_id)"><span>Upload Candidate</span></button>
                        <span class="f-14 font-weight-400 gen-ai-text" *ngIf="job?.groq_status == 'pending'">Screening in process</span>
                        <span class="text-blue pointer" (click)="viewCandidates(job)" *ngIf="job?.groq_status == 'completed'">View Candidates
                          </span>
                           <span matTooltip="Rename"  *ngIf="job?.groq_status == 'completed'" matTooltipClass="red-tooltip text-black" class="ml-2 pointer" (click)="openRenameProjectModel(job)">
                              <i class="fa-regular fa-ellipsis-vertical"></i>
                            </span>
                    </span>

                </div>
            </div>
        </div>
    </div>

    <!-- <div class="d-flex justify-content-center wccard ng-star-inserted email-campaign-pagination" *ngIf="totalCount > 1">
        <ngb-pagination [collectionSize]="totalCount" [maxSize]="5" aria-label="Custom pagination" [pageSize]="pageSize"
            rotate="false" (pageChange)="onPageChange($event)" [(page)]="currentPage" [ellipses]="false">
            <ng-template ngbPaginationPrevious> Previous </ng-template>
            <ng-template ngbPaginationNext> Next </ng-template>
        </ngb-pagination>
    </div> -->
</div>
<div class="new-card d-flex justify-content-center wccard align-items-center"
    [ngClass]="{'sticky-pagination': isScrolled}" *ngIf="totalCount > 1">
    <ngb-pagination [collectionSize]="totalCount" [maxSize]="5" [pageSize]="profilesPerPage" [rotate]="true"
        (pageChange)="setPage($event)" [(page)]="currentPage">
        <ng-template ngbPaginationPrevious> <span></span></ng-template>
        <ng-template ngbPaginationNext>
            <span>Next</span>
        </ng-template>
    </ngb-pagination>

    <div class="page-selection">
        Showing
        <select data-testid="auto-app-resume-screen-select-1" class="wc-select" name="" id="" [(ngModel)]="profilesPerPage" (change)="updatePagePreference()">
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
        </select>
        Projects per page
    </div>
</div>

<!-- For import jobs model -->
<ng-template #importJobsModel class="modal">
    <div class="modal-content p-3">
        <div class="d-flex justify-content-between align-items-center pb-2 mb-2" style="border-bottom: 1px solid rgba(217, 217, 217, 1);">
            <span class="f-14 font-weight-600">Import Job for {{modelJobsListDetails?.atsName | titlecase}}</span>
            <span class="pointer f-16" (click)="dismiss()"><i class="fa-solid fa-xmark"></i></span>
        </div>
        <div class="row">

            <!-- Empty Screen Loader-->
            <div *ngIf="importJobListLoader" class="col">
                <div class="w-100" style="height: 439px; display: flex; justify-content: center; align-items: center;">
                    <div>
                        <img style="width: 70px; height: 70px;" src="../../assets/rolling-loader.gif" alt="empty_logo">
                    </div>
                </div>
            </div>

            <!-- If jobs List Not Available -->
            <div *ngIf="modelJobsList.length === 0 && !importJobListLoader" class="col">
                <div class="w-100 wccard"
                    style="height: 439px; display: flex; justify-content: center; align-items: center;">
                    <div>
                        <img style="width: 203px; height: 132px;" src="../../../assets/empty-credit.png"
                            alt="empty_logo">
                        <p class="f-14 font-weight-500" style="color: #969696;">No job Created Yet, Start Creating!</p>
                    </div>
                </div>
            </div>

            <!-- If job List Available -->
            <div class="col" *ngIf="modelJobsList.length > 0">
                <!-- Table Header Row -->
                <div class="wccard pb-2 px-3 mb-2" style="border-bottom: 1px solid rgba(217, 217, 217, 1);">
                    <div class="row">
                        <div class="col-5">
                            <span class="f-14 font-weight-400" style="color: #969696;">Job Title</span>
                        </div>
                        <!-- <div class="col">
                            <span class="f-14 font-weight-400" style="color: #969696;">Location</span>
                        </div> -->
                        <div class="col">
                            <span class="f-14 font-weight-400" style="color: #969696;">Updated On</span>
                        </div>
                        <div class="col">
                            <span class="f-14 font-weight-400" style="color: #969696;">Status</span>
                        </div>
                        <div class="col  text-right">
                            <span class="f-14 font-weight-400" style="color: #969696;">Action</span>
                        </div>
                    </div>
                </div>

                <!-- Data Rows -->
                <div class="wccard joblistrow" *ngFor="let job of modelJobsList">
                    <div class="row">
                        <div class="col-5 text-truncate">
                            <div class="d-flex">
                                <div class="companylogo">
                                     <img src={{logo}} alt="logo">
                                </div>
                                <div>
                                    <p class="f-14 font-weight-normal pointer text-9696 mb-1 text-truncate" matTooltip="{{job.name}}" [matTooltipClass]="{ 'red-tooltip text-black': true }" style="width: 200px;">
                                        {{ job.name | titlecase }}
                                    </p>
                                    <p class="mb-0">
                                        <span class="f-12 font-weight-400 text-9696">
                                            <span><i class="fa-regular fa-location-dot"></i></span> {{ job.location | titlecase }}
                                        </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col d-flex align-items-center">
                            <span class="f-14 font-weight-500 text-9696">
                                <i class="fa-regular fa-clock mr-1"></i>
                                {{ job.createdAt | date: 'MMM d, y' }}
                            </span>
                        </div>

                        <div class="col d-flex align-items-center">
                            <span class="f-14 font-weight-400 active-label">
                                {{ job.status | titlecase }}
                            </span>
                        </div>
                        <div class="col d-flex align-items-center justify-content-end">
                            <button data-testid="auto-app-resume-screen-button-6" class="btn-trms-small w-100"
                                [ngClass]="{ 'text-center': importJobLoader, 'bg-gray': importJobLoader && job?.id != selectedJobIdForImport }"
                                (click)="importJobDetails(job?.id)" [disabled]="importJobLoader">
                                <span *ngIf="job?.id == selectedJobIdForImport">
                                    <span [ngClass]="{ 'spinner-border text-white spinner-size': importJobLoader }"
                                        [ngStyle]="importJobLoader ? { width: '20px', height: '20px' } : {}">
                                        {{ importJobLoader ? '' : 'Import' }}
                                    </span>
                                </span>
                                <span *ngIf="job?.id != selectedJobIdForImport">Import</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</ng-template>


<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
    <span class="successCheck"><i class="fal fa-check"></i> </span>
    <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
    <span class="errorCheck"><i class="fal fa-times"></i></span>
    <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>

<ngb-alert class="ngb-alert" style="background-color: yellow !important;" *ngIf="infoMessage" type="info"
    (close)="infoMessage = ''">
    <span class="infoCheck"><i class="fal fa-info-circle"></i></span>
    <span class="infomsg ml-1">{{ infoMessage }}</span>
</ngb-alert>
<!-- For Rename Project model -->
<ng-template #renameProjectModel class="modal">
  <div class="modal-content p-3">
    <div class="d-flex justify-content-between align-items-center">
      <h5 class="f-14 font-weight-600" id="experience">Rename Job</h5>

      <span class="f-14 font-weight-600"></span>
      <span class="pointer f-12" (click)="dismiss()"><i class="fa-solid fa-xmark"></i></span>
    </div>
    <div class="d-flex flex-column w-100 mt-2">
      <input data-testid="auto-app-resume-screen-input-2" [formControl]="renameProjectInput" placeholder="Enter Job Name" type="text"
        class="wc-form-control nobg">
      <span class="f-12 text-danger mt-1" *ngIf="renameProjectError">Duplicate Tag</span>
      <span class="f-12 text-danger mt-1" *ngIf="renameProjectInputSpecialCharError">Special Character Not
        Allowed</span>
    </div>

    <div class="row mt-2">
      <div class="col text-right">
        <button data-testid="auto-app-resume-screen-button-7" class="btn-trms-small" [ngClass]="{ 'text-center': showSpinnerLoader }" (click)="renameProject()"
          [disabled]="showSpinnerLoader || renameProjectInputSpecialCharError || renameProjectError">
          <span [ngClass]="{ 'spinner-border text-blue spinner-size': showSpinnerLoader }"
            [ngStyle]="{ 'width: 20px; height: 20px;': showSpinnerLoader }">
            {{showSpinnerLoader ? '' : 'Save'}}
          </span>
        </button>
      </div>
    </div>
  </div>
</ng-template>
